import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function TrialSuccess() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-4434">
      <div className="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-4435">
        <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-4436">
          <Link to="/" className="flex justify-center" data-id="element-4437">
            <div className="relative" data-id="element-4438">
              <span className="text-2xl font-bold text-blue-900" data-id="element-4439">
                Elevate<span className="text-yellow-500" data-id="element-4440">IT</span>
              </span>
              <span className="text-sm font-normal ml-0.5 text-blue-600" data-id="element-4441">
                .fr
              </span>
              <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-4442"></div>
            </div>
          </Link>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-4443">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center" data-id="element-4444">
            <div className="flex justify-center" data-id="element-4445">
              <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center" data-id="element-4446">
                <CheckCircleIcon className="h-10 w-10 text-green-600" data-id="element-4447" />
              </div>
            </div>
            <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900" data-id="element-4448">
              Félicitations !
            </h2>
            <p className="mt-2 text-center text-base text-gray-600" data-id="element-4449">
              Votre période d'essai gratuit de 7 jours a été activée avec
              succès.
            </p>
            <div className="mt-8 bg-blue-50 rounded-lg p-4 text-left" data-id="element-4450">
              <h3 className="text-lg font-medium text-blue-900 mb-2" data-id="element-4451">
                Prochaines étapes :
              </h3>
              <ul className="space-y-2" data-id="element-4452">
                {['Vérifiez votre email pour confirmer votre compte', 'Configurez vos préférences et alertes', "Explorez les appels d'offres disponibles", 'Contactez notre équipe si vous avez des questions'].map((step, index) => <li key={index} className="flex items-start" data-id="element-4453">
                    <div className="flex-shrink-0 h-5 w-5 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-4454">
                      <CheckCircleIcon size={12} className="text-blue-600" data-id="element-4455" />
                    </div>
                    <span className="text-sm text-blue-700" data-id="element-4456">{step}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-8 space-y-3" data-id="element-4457">
              <Button variant="secondary" fullWidth size="lg" className="shadow-md" onClick={() => window.location.href = '/dashboard'} data-id="element-4458">
                Accéder à mon tableau de bord
                <ArrowRightIcon size={16} className="ml-2" data-id="element-4459" />
              </Button>
              <p className="text-sm text-gray-600" data-id="element-4460">
                Vous avez des questions ?{' '}
                <a href="mailto:support@elevateit.fr" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-4461">
                  Contactez notre support
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-gray-50 border-t border-gray-200 py-6" data-id="element-4462">
        <div className="container mx-auto px-4" data-id="element-4463">
          <div className="text-center text-sm text-gray-600" data-id="element-4464">
            <p data-id="element-4465">© 2025 ElevateIT. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>;
}